"use strict";
// (C) 2007-2020 GoodData Corporation
Object.defineProperty(exports, "__esModule", { value: true });
exports.ColorPickerPointer = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
/**
 * @internal
 */
exports.ColorPickerPointer = function () {
    return react_1.default.createElement("div", { className: "color-picker-pointer" });
};
//# sourceMappingURL=ColorPickerPointer.js.map